import React from 'react';
import { motion } from 'framer-motion';
import { CalendarClock } from 'lucide-react';
import { QuizForm } from './QuizForm';
export function EventsPage() {
  return <main data-id="element-35">
      <section className="pt-40 pb-24 md:pt-48 md:pb-32 px-6 md:px-12 bg-cream" data-id="element-36">
        <div className="max-w-3xl mx-auto text-center" data-id="element-37">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="mb-16" data-id="element-38">
            <div className="w-16 h-16 bg-marigold/20 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-39">
              <CalendarClock className="w-8 h-8 text-marigold" data-id="element-40" />
            </div>
            <span className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-marigold mb-4 block" data-id="element-41">
              Events
            </span>
            <h1 className="text-4xl md:text-5xl text-navy mb-6 font-serif tracking-wide" data-id="element-42">
              Events coming soon
            </h1>
            <p className="text-lg text-navy/70 font-light leading-relaxed" data-id="element-43">
              We're putting together gatherings, tours, and conversations for
              the Familiar Spaces community. In the meantime, fill out the form
              below and we'll make sure you're the first to know.
            </p>
          </motion.div>

          <QuizForm data-id="element-44" />
        </div>
      </section>
    </main>;
}